module.exports = __webpack_public_path__ + "static/photo-55d8ce00c8583ea56909f70febc1c79f.jpg";